import { RootState } from '../../store';

export const selectLabResults = (state: RootState) => state.labResults.list;

export const selectListError = (state: RootState) => state.labResults.listError;

export const selectCurrentLabResult = (state: RootState) => state.labResults.current;

export const selectCurrentError = (state: RootState) => state.labResults.currentError;

export const selectLoading = (state: RootState) => state.labResults.loading;

export const selectPaging = (state: RootState) => state.labResults.paging;